import React from 'react';
import {
	PatternBase,
	canvasSize,
	strokeWidth,
	patternRotate,
} from './PatternBase';

const lineSpacing = canvasSize / 2;

export const LinesForeward = () => {
	const lines = [];

	for (let x2 = -canvasSize; x2 <= canvasSize; x2 += lineSpacing) {
		lines.push(
			<line
				key={x2}
				x1={x2 + canvasSize + 1}
				x2={x2 + -1}
				y1="-1"
				y2={canvasSize + 1}
			/>,
		);
	}

	return lines;
};

export const StripesForewardThinPattern = ({
	foregroundColor,
	backgroundColor,
	id,
}) => {
	return (
		<PatternBase
			id={id}
			backgroundColor={backgroundColor}
			patternTransform={`rotate(${-patternRotate})`}
		>
			<g stroke={foregroundColor} strokeWidth={strokeWidth}>
				<LinesForeward />
			</g>
		</PatternBase>
	);
};

export const StripesForewardThickPattern = ({
	foregroundColor,
	backgroundColor,
	id,
}) => {
	return (
		<PatternBase
			id={id}
			backgroundColor={foregroundColor}
			patternTransform={`rotate(${-patternRotate})`}
		>
			<g stroke={backgroundColor} strokeWidth={strokeWidth}>
				<LinesForeward />
			</g>
		</PatternBase>
	);
};
